import { useToggle, useMedia } from '@packlink/utils';
import { ParcelTrackingStatus } from './ParcelTrackingStatus/ParcelTrackingStatus.js';
import { ParcelTrackingTimelineDisplayButton } from './ParcelTrackingTimelineDisplayButton.js';
import { ParcelMeasures } from './TrackingTimeline/ParcelMeasures/ParcelMeasures.js';
import { getParcelTrackingStyles, getParcelTrackingAsideStyles, getParcelTrackingContentStyles, getParcelTrackingDetailsSummaryStyles, getParcelTrackingDetailsSummaryWrapperStyles, getParcelTrackingTimelineWrapperStyles } from './ParcelTrackingStyles.js';
import { useTheme } from '@emotion/react';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { TrackingNumberAside } from './TrackingTimeline/TrackingNumberAside/TrackingNumberAside.js';
import { TrackingTimeline } from './TrackingTimeline/TrackingTimeline.js';

function ParcelTracking(_ref) {
  let {
    parcel: {
      currentStatus,
      checkpoints,
      carrierTrackingNumber,
      name,
      width,
      height,
      length,
      trackingUrl
    },
    alwaysShowTimeline = false,
    showAsides = true,
    ...otherProps
  } = _ref;
  const parcelMeasures = {
    name,
    width,
    height,
    length
  };
  const {
    state,
    toggle
  } = useToggle(alwaysShowTimeline);
  const theme = useTheme();
  const isFromTablet = useMedia(theme.mediaQuery('tablet'));
  return jsxs("article", {
    css: getParcelTrackingStyles,
    ...otherProps,
    children: [showAsides && jsx("aside", {
      css: getParcelTrackingAsideStyles,
      children: jsx(ParcelMeasures, {
        ...parcelMeasures
      })
    }), !isFromTablet && jsx(TrackingNumberAside, {
      carrierTrackingNumber: carrierTrackingNumber,
      trackingUrl: trackingUrl
    }), jsxs("details", {
      open: state,
      css: getParcelTrackingContentStyles,
      role: "presentation",
      children: [jsx("summary", {
        css: getParcelTrackingDetailsSummaryStyles,
        onClick: preventDefaultBehavior,
        children: jsxs("span", {
          css: getParcelTrackingDetailsSummaryWrapperStyles,
          children: [jsx(ParcelTrackingStatus, {
            status: currentStatus
          }), !alwaysShowTimeline && jsx(ParcelTrackingTimelineDisplayButton, {
            open: state,
            onToggle: toggle
          })]
        })
      }), jsxs("section", {
        css: getParcelTrackingTimelineWrapperStyles,
        children: [jsx(TrackingTimeline, {
          "data-id": "parcel-tracking-timeline",
          checkpoints: checkpoints
        }), showAsides && isFromTablet && jsx(TrackingNumberAside, {
          carrierTrackingNumber: carrierTrackingNumber,
          trackingUrl: trackingUrl
        })]
      })]
    })]
  });
}
function preventDefaultBehavior(e) {
  e.preventDefault();
}

export { ParcelTracking };
//# sourceMappingURL=ParcelTracking.js.map
